/**
 * Barrel — single import surface for the raw axios services.
 *
 * Usage in mappers / hooks:
 *   import { backendApi } from '../backend/services';
 *   const day = await backendApi.board.getDay('2026-08-12');
 */

import { crewService } from './crew.service';
import { dispatchActivityService } from './dispatch-activity.service';
import { dispatchBoardService } from './dispatch-board.service';
import { attachmentService } from './attachment.service';

export const backendApi = {
  crew: crewService,
  activity: dispatchActivityService,
  board: dispatchBoardService,
  attachment: attachmentService,
} as const;

export { crewService, dispatchActivityService, dispatchBoardService, attachmentService };
